import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X, ChevronDown } from "lucide-react";

const PenaltyLedgerFlyout = ({
  isPenaltyLedger,
  handleClosePenaltyLedger,
  accountNumber,
  ledger = [],
  account,
  penaltyCurrentPage,
  setPenaltyCurrentPage,
  penaltyLimit,
  setPenaltyLimit,
  penaltyDisplayedPage,
  setPenaltyDisplayedPage,
  penaltyTotalPages,
  penaltyTotalRecords,
  Pagination,
  //   handleExport,
}) => {
  const handlePenaltyPageChange = (page) => {
    setPenaltyCurrentPage(page);
  };

  const handlePenaltyLimitChange = (e) => {
    setPenaltyLimit(Number(e.target.value));
    setPenaltyCurrentPage(1);
  };
  return (
    <SlidePanel
      isOpen={isPenaltyLedger}
      onClose={handleClosePenaltyLedger}
      width={600}
    >
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Close Button */}
        <button
          onClick={handleClosePenaltyLedger}
          className="absolute top-1 right-1 z-20"
        >
          <X size={25} strokeWidth={1} className="text-[#202020]" />
        </button>

        <div className="flex flex-col h-full px-3 pt-10">
          {/* Title */}

          <h2 className="text-[20px] font-[600] text-[#000000]">
            Penalty Ledger – {account} [{accountNumber}]
          </h2>

          {/* Description */}

          <p className="text-[#4A4747] text-[14px] mt-1">
            Outstanding penalties for late share remittances under account [
            {accountNumber}].
          </p>

          {/* Export */}

          <div className="flex justify-end mt-3">
            <button
              //   onClick={handleExport}
              className="flex items-center gap-4 bg-[#FAFAFA] border border-[#A6A6A6] rounded-md h-[40px] px-3 bg-white"
            >
              <span className="text-[14px] text-[#060606] font-medium">
                EXPORT
              </span>

              <ChevronDown size={18} strokeWidth={2} />
            </button>
          </div>
          {/* Table */}
          <div className="mt-3 flex-1 flex flex-col overflow-hidden">
            {/* Header */}
            <div className="flex bg-[#E3F8FF] py-1 text-center font-normal text-[14px] flex-shrink-0">
              <div className="w-[18%]">#RefNo</div>

              <div className="w-[28%]">DATE</div>

              <div className="w-[18%]">
                CHARGE
                <br />
                (KES)
              </div>

              <div className="w-[18%]">
                RECOVERED
                <br />
                (KES)
              </div>

              <div className="w-[20%]">
                OUTSTANDING
                <br />
                BALANCE (KES)
              </div>
            </div>

            {/* Scrollable Rows */}
            <div className="flex-1 overflow-y-auto">
              {ledger?.length > 0 ? (
                ledger.map((item) => (
                  <div
                    key={item?.refNo}
                    className="flex items-center py-3 text-center"
                  >
                    <div className="text-[#1473E6] font-medium w-[18%]">
                      {item?.refNo}
                    </div>

                    <div className="w-[28%]">
                      {item?.date
                        ? new Date(item.date)
                            .toLocaleString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "numeric",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace(",", "")
                        : "N/A"}
                    </div>

                    <div className="w-[18%]">
                      {Number(item?.chargeAmount).toLocaleString()}
                    </div>

                    <div className="w-[18%]">
                      {Number(item?.recoveredAmount).toLocaleString()}
                    </div>

                    <div className="w-[20%]">
                      {Number(item?.outstandingBalance).toLocaleString()}
                    </div>
                  </div>
                ))
              ) : (
                <div className="py-16 text-center text-[#8A8A8A]">
                  No penalty ledger available.
                </div>
              )}
            </div>
          </div>

          <div className="h-[70px] bg-white w-full px-[10px] flex items-center justify-between border-t">
            <div className="flex items-center gap-[20px]">
              <p className="text-[#074073] text-[14px]">Rows per page</p>

              <select
                name="page"
                id="page"
                className="w-[71px] border px-[5px] h-[30px] focus:outline-none"
                value={penaltyLimit}
                onChange={handlePenaltyLimitChange}
              >
                <option value="50">50</option>
                <option value="30">30</option>
                <option value="20">20</option>
                <option value="10">10</option>
              </select>

              <p className="text-[#074073] text-[14px]">
                {penaltyDisplayedPage} / {penaltyTotalPages} (
                {penaltyTotalRecords} records)
              </p>
            </div>

            <Pagination
              currentPage={penaltyCurrentPage}
              totalPages={penaltyTotalPages}
              onPageChange={handlePenaltyPageChange}
            />
          </div>

          {/* Footer */}

          <div className="flex justify-end py-3">
            <button
              onClick={handleClosePenaltyLedger}
              className="bg-[#0A4E8A] hover:bg-[#083D6B] text-white px-10 py-3 rounded-lg font-medium"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default PenaltyLedgerFlyout;
